export function clearLocalStorage() {
  const internalZynkaUser = localStorage.getItem('internalZynkaUser')
  localStorage.clear()
  if (internalZynkaUser) localStorage.setItem('internalZynkaUser', internalZynkaUser)
}
